import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { NumericFormat } from 'react-number-format';

// Formatuesi i brendshëm
const EuroFormat = React.forwardRef(function EuroFormat(props, ref) {
  const { onChange, decimalScale: ds, ...other } = props;
  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values, sourceInfo) => {
        if (sourceInfo?.source !== "event") return;
        onChange({ target: { name: props.name, value: values.floatValue } });
      }}
      thousandSeparator=","
      decimalSeparator="."
      decimalScale={ds ?? 4}
      fixedDecimalScale
      allowNegative={false}
    />
  );
});

const PriceField = ({
  label,
  value,
  onChange,
  onBlur,
  name,
  disabled,
  decimalScale,
  InputProps: externalInputProps,
  sx: externalSx,
}) => {
  const mergedInputProps = {
    ...(externalInputProps || {}),
    inputComponent: EuroFormat,
    inputProps: {
      ...(externalInputProps?.inputProps || {}),
      decimalScale,
    },
    startAdornment:
      externalInputProps?.startAdornment || (
        <InputAdornment position="start">€</InputAdornment>
      ),
  };

  return (
    <TextField
      label={label}
      name={name}
      variant="filled"
      fullWidth
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      InputProps={mergedInputProps}
      sx={{
        "& .MuiFilledInput-root": { backgroundColor: "#fff" },
        "& .MuiFilledInput-root:hover": { backgroundColor: "#fff" },
        "& .MuiFilledInput-root.Mui-focused": { backgroundColor: "#fff" },
        ...(externalSx || {}),
      }}
    />
  );
};

export default PriceField;
